export const validateNpiNumber = (npiNumber: string | undefined): string | undefined => !npiNumber
    ? undefined
    : !/^\d{10}$/.test(npiNumber)
        ? "NPI Number must be a 10 digit number"
        : undefined;
